import React, { FC, useEffect, useState } from 'react';
import { IBasicRtHero } from '../../interfaces/umbracoNodes/contentSection';

import * as StyledSection from './basicRtHero.styles';

interface Props {
	content: IBasicRtHero;
}

const BasicRtHero: FC<Props> = ({ content }) => {
	const [showVideo, setShowVideo] = useState(false);

	useEffect(() => {
		if (!showVideo && content.Values.Image) {
			if (content.Values.Image.Src.includes('.mp4')) {
				setShowVideo(true);
			}
		}
	}, [showVideo, setShowVideo, content]);

	return (
		<StyledSection.Wrapper>
			<StyledSection.ShowcaseSectionColumns reverseOrder={content.Values.ImageLeft}>
				{content.Values.Title && (
					<StyledSection.ContentColumn desktopSmall={1 / 2}>
						<StyledSection.ContentWrapper>
							{content.Values.Title && content.Values.Title.length > 0 && (
								<StyledSection.Title>{content.Values.Title}</StyledSection.Title>
							)}
							{content.Values.Subtitle && content.Values.Subtitle.length > 0 && (
								<StyledSection.Subtitle>{content.Values.Subtitle}</StyledSection.Subtitle>
							)}
							<StyledSection.Text dangerouslySetInnerHTML={{ __html: content.Values.Text }} />
						</StyledSection.ContentWrapper>
					</StyledSection.ContentColumn>
				)}
				<StyledSection.ImageColumn desktopSmall={content.Values.Title === '' ? 1 : 1 / 2}>
					{!showVideo && content.Values.Image && (
						<StyledSection.ShowcaseSectionImage
							containImage
							hidePlaceholder
							useCrop={false}
							image={content.Values.Image.Src}
						/>
					)}
				</StyledSection.ImageColumn>
			</StyledSection.ShowcaseSectionColumns>
		</StyledSection.Wrapper>
	);
};

export default BasicRtHero;
